import { CloudIcon, PaperClipIcon } from '@heroicons/react/24/outline';
import React, { useEffect, useMemo, useState } from 'react';
import moment from 'moment';
import { useDropzone } from 'react-dropzone';
import { useNavigate } from 'react-router-dom';
import { FunnelIcon, ViewColumnsIcon } from '@heroicons/react/24/outline';

import {
	deleteDocument,
	getDocuments,
	uploadDocument,
} from '../../../api/documents';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { Button } from '../../../components/Button';
import useAsync from '../../../hooks/useAsync';
import useModal from '../../../hooks/useModal';
import { removeAssetDocument } from '../../../api';
import { classNames } from '../../../components/helpers/functions';
import { getModuleCategories } from '../../../api/modules';
import DataTable from '../../../components/DataTable';
import usePrevious from '../../../hooks/usePrevious';
import useSearchParams from '../../../hooks/useSearchParams';
import SimpleTable from '../../../components/Table/SimpleTable';
import { PageHeading } from '../../../components/Shell/Content';

const DOCUMENTS_MODULE_ID = process.env.REACT_APP_MODULE_ID_DOCUMENTS;

export default ({ item, bare, categories }) => {
	const navigate = useNavigate();
	const { open, setOpen, setClose } = useModal('deleteModal');
	const { setOpen: openUploadDocumentsModal } = useModal('uploadDocuments');

	const {
		page: pageFilter,
		category: categoryFilter,
		sortBy: sortByFilter,
		sortOrder: sortOrderFilter,
	} = useSearchParams();

	const { open: isUploadDocumentsOpen, setOpen: openUploadDocuments } =
		useModal('uploadDocuments');

	const [currentTab, setCurrentTab] = useState('all');

	const { execute: onRemoveDocument, status: removingDocument } = useAsync(
		removeAssetDocument,
		{ immediate: false },
	);

	const { execute: onDeleteDocument, status: deletingDocument } = useAsync(
		deleteDocument,
		{ immediate: false },
	);

	const {
		value: uploadedDocs,
		execute: upload,
		status,
	} = useAsync(uploadDocument, {
		immediate: false,
		showNotification: { success: 'Successfully uploaded document' },
	});

	const { value: documents, execute: onRefreshDocuments } = useAsync(
		getDocuments,
		{
			...(item?.id
				? {
						defaultPayload: {
							assetId: item?.id,
							categoryId: categoryFilter || 'all',
						},
					}
				: { defaultPayload: { categoryId: categoryFilter || 'all' } }),
		},
	);
	const { value: localCategories, execute: onRefreshCategories } = useAsync(
		getModuleCategories,
		{
			defaultPayload: { id: DOCUMENTS_MODULE_ID },
			silent: true,
			immediate: false,
		},
	);

	useEffect(() => {
		if (!categories) {
			onRefreshCategories();
		}
	}, [categories]);

	const { acceptedFiles, isDragActive, getRootProps, getInputProps } =
		useDropzone({
			accept: 'application/pdf',
		});

	const handleTabChange = (tab) => {
		const search = new URLSearchParams();
		search.append('category', tab);
		setCurrentTab(tab);

		navigate({ search: search ? search.toString() : '' });
	};

	useEffect(() => {
		if (pageFilter || categoryFilter) {
			onRefreshDocuments(
				{
					page: pageFilter,
					categoryId: categoryFilter || currentTab,
					sortBy: sortByFilter,
					sortOrder: sortOrderFilter,
				},
				null,
				{
					silent: true,
				},
			);

			if (categoryFilter) {
				setCurrentTab(categoryFilter);
			}
		}
	}, [pageFilter, categoryFilter, sortByFilter, sortOrderFilter]);

	const prevIsUploadDocumentsOpen = usePrevious(isUploadDocumentsOpen);

	useEffect(() => {
		if (!isUploadDocumentsOpen && prevIsUploadDocumentsOpen) {
			onRefreshDocuments(null, null, {
				silent: true,
			});
		}
	}, [isUploadDocumentsOpen]);

	useEffect(() => {
		if (acceptedFiles.length) {
			upload(
				{
					files: acceptedFiles,
					bucket: 'tes2t',
					information: {
						...(item?.id ? { assetId: item?.id } : {}),
					},
				},
				() => {
					onRefreshDocuments(null, null, {
						silent: true,
					});
				},
			);
		}
	}, [acceptedFiles]);

	const documentBreakdown = useMemo(() => {
		return (
			documents?.allRows?.reduce(
				(all, doc) => {
					if (doc?.categoryId) {
						if (all[doc?.categoryId]) {
							all[doc?.categoryId].push(doc);
						} else {
							all[doc?.categoryId] = [doc];
						}
					} else {
						all['uncategorized'].push(doc);
					}

					return all;
				},
				{ uncategorized: [] },
			) || { uncategorized: [] }
		);
	}, [documents]);

	//const documentBreakdown =

	const actualCategories = categories || localCategories;

	const documentCategories = actualCategories
		? actualCategories
				?.map((category) => ({
					name: category?.name,
					onClick: () => {
						handleTabChange(category?.id);
					},
					id: category?.id,
					current: currentTab === category?.id,
					...(documentBreakdown[category?.id]
						? { count: documentBreakdown[category?.id]?.length }
						: {}),
				}))
				?.sort((a, b) => a.name?.localeCompare(b.name))
		: [];

	console.log('docs: ', documents);

	return (
		<>
			<div className="block sm:hidden">
				{/*<h2 className="flex sm:items-baseline flex-col sm:flex-row text-base/7 font-semibold text-zinc-950 sm:text-sm/6 mr-4">
					Documents
				</h2>

				<div className="px-0 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
					<dd className="mt-2 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
						<ul
							role="list"
							className="divide-y divide-gray-100 rounded-md border border-gray-200"
						>
							<li className="flex items-center justify-between py-4 pr-5 pl-4 text-sm/6">
								<div className="flex w-0 flex-1 items-center">
									<PaperClipIcon
										aria-hidden="true"
										className="size-5 shrink-0 text-gray-400"
									/>
									<div className="ml-4 flex min-w-0 flex-1 gap-2">
										<div>
											<div className="truncate font-medium text-gray-900">
												resume_back_end_developer.pdf
											</div>
											<div className="shrink-0 text-gray-400">2.4mb</div>
										</div>
									</div>
								</div>
							</li>
						</ul>
					</dd>
				</div>*/}
			</div>
			<div className="hidden sm:block grid grid-cols-12 py-4">
				<div className="flex items-center justify-between">
					<div className=" text-lg font-semibold">
						<span className="block sm:hidden">Documents</span>
					</div>
					<div className="flex items-center">
						<Menu as="div" className="relative inline-block">
							<Menu.Button
								className={classNames(
									'ml-0 sm:ml-3 inline-flex items-center rounded-md border px-4 py-4 sm:py-2 text-xs font-medium border-gray-300 bg-white text-gray-700 shadow-sm hover:bg-gray-50',
								)}
							>
								{currentTab === 'all'
									? 'Document Type'
									: currentTab === 'uncategorized'
										? 'Uncategorized'
										: documentCategories?.find((o) => o.id === currentTab)
												?.name}
								<ChevronDownIcon
									aria-hidden="true"
									className="-mr-1 ml-1 size-5 text-gray-400"
								/>
							</Menu.Button>

							<Menu.Items
								transition
								className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg outline-1 outline-black/5 transition data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in"
							>
								{[
									{
										name: 'All',
										onClick: () => {
											handleTabChange('all');
											//navigate({ search: '' });
										},
										current: currentTab === 'all' || !currentTab,
										count: documents?.absoluteTotal,
									},

									...documentCategories,

									{
										name: 'Uncategorized',
										onClick: () => {
											handleTabChange('uncategorized');
										},
										current: currentTab === 'uncategorized',
										count: documentBreakdown?.uncategorized?.length,
									},
								].map((type) => (
									<div className="py-1">
										<Menu.Item>
											<a
												onClick={() => type?.onClick()}
												className="block px-4 py-2 text-xs text-gray-700 hover:bg-gray-50 data-focus:bg-gray-100 data-focus:text-gray-900 data-focus:outline-hidden"
											>
												{type?.name}
											</a>
										</Menu.Item>
									</div>
								))}
							</Menu.Items>
						</Menu>
						{/*<Button type="secondary">Add Existing Document</Button>*/}
						<Button
							Icon={CloudIcon}
							onClick={() => {
								openUploadDocumentsModal({
									moduleId: DOCUMENTS_MODULE_ID,
									assetId: item?.id,
								});
							}}
						>
							Upload Document
						</Button>
					</div>
				</div>

				<div className="mt-6">
					<DataTable
						disableScroll
						columns={[
							{
								header: 'Name',
								accessorKey: 'name',
								cell: (info) =>
									info?.row?.original?.loading
										? 'Uploading... '
										: info?.getValue() || '',
							},
							{
								header: 'Category',
								accessorKey: 'categoryId',
								cell: (info) => {
									const category = info?.row?.original?.category;
									if (category) {
										return category?.name;
									} else {
										return '';
									}
								},
							},
							{
								header: 'Created On',
								accessorKey: 'createdAt',
								cell: (info) => {
									const original = info?.row?.original?.createdAt;
									return info?.getValue()
										? moment(info?.getValue()).format(
												'ddd, MMM Do, YYYY [at] h:mmA',
											)
										: '';
								},
							},
						]}
						data={{
							...documents,
							//rows: showingDocuments,
							//total: documents?.count || [],
						}}
						usePagination={false}
						useExport={false}
						hasCheckboxes={false}
						useSearch={false}
						disableTitle={true}
						disable
						manualSorting={false}
						initialState={{ sortBy: ['createdAt', 'ASC'] }}
						rowActions={[
							{
								name: 'Edit',
								onClick: (info) => {
									openUploadDocuments({
										id: info?.original?.id,
										moduleId: DOCUMENTS_MODULE_ID,
									});
								},
							},
							...(item?.id
								? [
										{
											name: 'Remove from Asset',
											onClick: (info) =>
												setOpen({
													title:
														'Are you sure you want to remove this document from this asset?',
													description:
														'Please note, this document will only be removed from this asset, not the system.',
													confirmText: 'Remove Document',
													onConfirm: () =>
														onRemoveDocument(
															{
																id: item?.id,
																documentId: info?.original?.id,
															},
															() => {
																setClose();
																onRefreshDocuments(null, null, {
																	silent: true,
																});
															},
														),
												}),
										},
									]
								: []),

							{
								name: 'Delete Document',
								danger:
									'Are you sure you want to permanently delete this document?',
								title:
									'Are you sure you want to permanently delete this document?',
								description:
									"Please note, this document will be completely deleted from the system, including it's attachment from any other asset",
								confirmText: 'Delete Document',
								onClick: (info) =>
									onDeleteDocument(
										{
											id: info?.original?.id,
										},
										() => {
											setClose();
											onRefreshDocuments(null, null, {
												silent: true,
											});
										},
									),
							},
						]}
						onRow={(info) => window.open(info?.original?.location, '_blank')}
					/>
				</div>
			</div>
		</>
	);

	return (
		<>
			<div class="md:flex flex-col md:flex-row md:min-h-screen w-full">
				<div class="flex flex-col w-full md:w-64 text-gray-700 bg-white dark-mode:text-gray-200 dark-mode:bg-gray-800 flex-shrink-0"></div>
			</div>
			<div>Content</div>
		</>
	);

	return (
		<div className="py-4">
			{!bare ? (
				<div
					className="w-full border-2 border-dashed rounded-md flex items-center justify-center py-12 text-center text-xs text-gray-700 cursor-pointer"
					{...getRootProps()}
					style={{ marginBottom: 15 }}
				>
					<input {...getInputProps()} />
					{isDragActive ? (
						<p>Place files here</p>
					) : (
						<div className="drop-container text-center">
							<CloudIcon className={'w-12 h-12 m-auto mb-2'} />
							<p>Upload a PDF</p>
						</div>
					)}
				</div>
			) : (
				<div className="text-md my-3 font-medium tracking-tight text-gray-700 items-center border-b pb-3">
					Documents
				</div>
			)}
			{showingDocuments?.length ? (
				<ul
					role="list"
					className="divide-y divide-gray-200 rounded-md border border-gray-200"
				>
					{showingDocuments?.map((attachment) => (
						<li
							key={attachment.name}
							className="flex items-center justify-between py-3 pl-3 pr-4 text-sm"
						>
							<div className="flex w-0 flex-1 items-center">
								{attachment?.loading ? (
									<div role="status">
										<svg
											aria-hidden="true"
											class="w-5 h-5 mr-2 text-gray-200 animate-spin dark:text-gray-200 fill-blue-600"
											viewBox="0 0 100 101"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
												fill="currentColor"
											/>
											<path
												d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
												fill="currentFill"
											/>
										</svg>
										<span class="sr-only">Loading...</span>
									</div>
								) : (
									<PaperClipIcon
										className="h-5 w-5 flex-shrink-0 text-gray-400"
										aria-hidden="true"
									/>
								)}

								<span className="ml-2 w-0 flex-1 truncate">
									{attachment?.path || attachment.name || 'Untitled'}
								</span>
							</div>
							{!attachment?.loading && (
								<div className="ml-4 flex-shrink-0">
									<a
										href={attachment.location}
										target="_blank"
										className="font-medium text-xs text-blue-600 hover:text-blue-500 cursor-pointer"
									>
										View
									</a>
									<Button
										className="hidden sm:inline-flex"
										type="ghost"
										onClick={() =>
											setOpen({
												title: 'Are you sure you want to remove this document?',
												confirmText: 'Remove Document',
												onConfirm: () =>
													removeDocument(
														{
															id: item?.id,
															documentId: attachment?.id,
														},
														() => {
															setClose();
															refresh({ id: item?.id }, null, { silent: true });
														},
													),
											})
										}
									>
										Remove
									</Button>
								</div>
							)}
						</li>
					))}
				</ul>
			) : null}
		</div>
	);
};
